import { useEffect, useState } from "react";
import { CheckCircle } from 'lucide-react';
import { Translator } from './translator';

const Success = () => {
  const { translateText, lang } = Translator();

  const baseText = {
        text1: "Pagamento completato",
        text2: "Grazie per il tuo pagamento!",
        text3: "Vai ai tuoi tour",
        text4: "Ricorda che hai 40 giorni per goderti il tour prima della scadenza."

  };

  const [translatedText, setTranslatedText] = useState(baseText);
  useEffect(() => {
    const translateAll = async () => {
        const entries = Object.entries(baseText);
        const translatedEntries = await Promise.all(
        entries.map(async ([key, value]) => [key, await translateText(value)])
        );
        setTranslatedText(Object.fromEntries(translatedEntries));
    };

  translateAll();
  }, [lang]);

  useEffect(() => {
    if (window.gtag) {
      window.gtag('event', 'conversion', {
        send_to: 'AW-17507143077/ABC123',
        value: 0,   // replace with a real purchase value
        currency: 'EUR'
      });
    }
  }, []);

  useEffect(() => {
    if (window.fbq) {
      window.fbq('track', 'Purchase', {
        value: 0,   // I should put order total
        currency: 'EUR'
      });
    }
  }, []);
  
  return (
    <div className="flex flex-col items-center justify-center py-16">
      <div className="bg-green-100 rounded-full p-4 mb-4">
        <CheckCircle className="w-12 h-12 text-[#49B15D]" />
      </div>
      <h1 className="text-2xl font-bold text-[#000000]">{translatedText.text1}</h1>
      <p className="mt-2 text-[#000000] w-full text-center">
        {translatedText.text2}
      </p>
      <button
        onClick={() => window.location.href = '/myTours'}
        className="mt-6 bg-[#49B15D] text-white px-6 py-2 rounded-full hover:bg-green-700 w-[90%]"
        style={{ width: '10%' }}
      >
        {translatedText.text3}
      </button>
<br />
        <span className="text-sm">
          {translatedText.text4}
        </span>

    </div>
  );
};

export default Success;
